import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { Tags } from '@tryghost/helpers-gatsby'
import { readingTime as readingTimeHelper } from '@tryghost/helpers'
import FeatureImage from '../components/common/FeatureImage'

import { Layout } from '../components/common'
import SocialIcons from '../components/common/SocialIcons'
import { MetaData } from '../components/common/meta'
import ContactForm from '../components/sections/contact-form'
import SocialSharer from '../components/common/SocialSharer'
import Toc from '../components/common/toc'

import {
	handleAudioPlayer,
	handleBeforeAfter,
	handleGallery,
	handleIframe,
	toggleFn,
	handleVideoPlayer,
} from "../utils/koenig-editor";

import '../styles/pages/post.scss'
import '../styles/base/code-syntax.scss'

/**
* Single post view (/:slug)
**/
const Post = ({ data, location, pageContext }) => {
    const post = data.ghostPost
    const { prev, next } = pageContext
    const readingTime = readingTimeHelper(post)
    let postImageAspectRatio = null;
    if (
            post.localFeatureImage
            && post.localFeatureImage.childImageSharp
            && post.localFeatureImage.childImageSharp.gatsbyImageData
        ) {
        let _image = post.localFeatureImage.childImageSharp.gatsbyImageData;
        postImageAspectRatio = _image.width / _image.height;
    }
    let postImageShape
    // Filter out null tags to prevent errors
    const filteredPost = {
        ...post,
        tags: post.tags ? post.tags.filter(tag => tag !== null) : []
    }
    let isPostpage = filteredPost.tags && filteredPost.tags.some(t=>t && t.name == "#postpage")
    let isBlogPost = filteredPost.tags && filteredPost.tags.some(t=>t && (t.slug === "blog" || t.slug === "page-blog"))
    let showTags = filteredPost.tags && filteredPost.tags.length > 0 && filteredPost.tags.some(t=>t && t.visibility == "public")

    useEffect(()=>{
        post.codeinjection_head && document.head.append(document.createRange().createContextualFragment(post.codeinjection_head))
        post.codeinjection_foot && document.body.append(document.createRange().createContextualFragment(post.codeinjection_foot))
        
        const contentBody = document.querySelector(".content-body");
        const galleryImages = contentBody.querySelectorAll('.kg-gallery-image img');
        const iframes = contentBody.querySelectorAll('iframe');
        const audioCardElements = contentBody.querySelectorAll('.kg-audio-card');
        const beforeAfterCards = contentBody.querySelectorAll('.kg-before-after-card');
        const toggleHeadingElements = contentBody.querySelectorAll(".kg-toggle-heading");
        const videoCardElements = contentBody.querySelectorAll('.kg-video-card');

        audioCardElements.forEach((audio) => handleAudioPlayer(audio));
        beforeAfterCards.forEach((card) => handleBeforeAfter(card));
        galleryImages.forEach((gallery) => handleGallery(gallery));
        toggleHeadingElements.forEach((heading) => heading.addEventListener('click', toggleFn, false));
        videoCardElements.forEach((video) => handleVideoPlayer(video));
        iframes.forEach((iframe)=> handleIframe(iframe));
    }, [])

    if ( postImageAspectRatio < 1 ) {
        postImageShape = 'portrait'
    } else if (postImageAspectRatio == 1) {
        postImageShape = 'square'
    } else {
        postImageShape = 'landscape'
    }

    return (
            <>
                <MetaData
                    data={data}
                    location={location}
                    type="article"
                />
                <Layout>
                    <article className="post__content">
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    <header className="post__header">
                                        <SocialIcons type={'light'} position={'absolute'}/>
                                        <div className="post__title">
                                            <h1>{post.title}</h1>
                                            {!isPostpage && <div className="post__details">
                                                <div className="post__detail-item">
                                                    <p className="post__details-header">Posted at:</p>
                                                    <p className="post__details-content">{post.published_at_pretty}</p>
                                                </div>
                                                <div className="post__detail-item">
                                                    <p className="post__details-header">Reading time:</p>
                                                    <p className="post__details-content">{readingTime}</p>
                                                </div>
                                            </div>}
                                            {showTags && <div className="post__tags"><Tags post={filteredPost} visibility="public" autolink={true} permalink="/tag/:slug" classes="post__tag" separator="/" separatorClasses="post__tag--separator" limit={5} /></div>}
                                        </div>
                                        <FeatureImage
                                            item={post}
                                            figureClass={`post__feature-image ${postImageShape}`}
                                            lazyload='auto'
                                        />
                                    </header>
                                    <section className="post__full-content">
                                        {isBlogPost && <Toc
                                        post={post}
                                        tocHeader={'Περιεχόμενο'}
                                        />}
                                        <section
                                            className="content-body load-external-scripts"
                                            dangerouslySetInnerHTML={{ __html: post.html }}
                                        />
                                    </section>
                                    <footer>
                                        <SocialSharer post={post} />
                                        {!isPostpage &&
                                            <aside className="post-adjasents">
                                                <div className="container">
                                                    {prev?
                                                    <div className="row">
                                                        <div className="col text-align-left">
                                                            <h2 className="post-adjasents__header h6">ΠΡΟΗΓΟΥΜΕΝΟ</h2>
                                                            <a href={prev.url} title={prev.title}>
                                                                <h3 className="post-adjasents__title h5">{prev.title}</h3>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    : null}
                                                    <hr className="hr--theme" />
                                                    {next?
                                                    <div className="row">
                                                        <div className="col text-align-right">
                                                            <h2 className="post-adjasents__header h6">ΕΠΟΜΕΝΟ</h2>
                                                            <a href={next.url} title={next.title}>
                                                                <h3 className="post-adjasents__title h5">{next.title}</h3>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    : null}
                                                </div>
                                            </aside>
                                        }
                                    </footer>
                                </div>
                            </div>
                        </div>
                        {isPostpage && <ContactForm />}
                    </article>
                </Layout>
            </>
    )
}

export default Post

export const postQuery = graphql`
    query($slug: String!) {
        ghostPost(slug: { eq: $slug }) {
            ...GhostPostFields
        }
    }
`
